
const Main = () => {
  return (
    null
    /*<section className="jumbotron text-center">
      <div className="container">
        <h2 className="jumbotron-heading">Softaculous ( Instalador - Aplicaciones )</h2>
        <p className="lead text-muted">
          Con nuestros planes podrás acceder al catálogo de 373 aplicaciones
          listas para instalar con unos pocos clicks.
        </p>
      </div>
    </section>*/
  )
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Global/Header/Main.js